/**
 * Направляющие выравнивания: пунктирные линии, которые появляются, когда
 * текущая точка встала ровно по оси другого угла плана. Дают понять,
 * почему сработала привязка, — как в графических редакторах.
 */
import type { SnapGuides } from "@/widgets/plan";
import type { ViewBox } from "@/shared/hooks/useViewport";

interface Props {
	guides: SnapGuides;
	box: ViewBox;
	mmPerPx: number;
}

export const AlignmentGuides = ({ guides, box, mmPerPx }: Props) => {
	if (guides.x === undefined && guides.y === undefined) return null;
	const dash = `${8 * mmPerPx} ${6 * mmPerPx}`;
	return (
		<g style={{ pointerEvents: "none" }}>
			{guides.x !== undefined && (
				<line
					x1={guides.x}
					y1={box.y}
					x2={guides.x}
					y2={box.y + box.h}
					stroke="#f59e0b"
					strokeWidth={mmPerPx}
					strokeDasharray={dash}
				/>
			)}
			{guides.y !== undefined && (
				<line
					x1={box.x}
					y1={guides.y}
					x2={box.x + box.w}
					y2={guides.y}
					stroke="#f59e0b"
					strokeWidth={mmPerPx}
					strokeDasharray={dash}
				/>
			)}
		</g>
	);
};
